import { useState, useEffect } from "react";
import EditIcon from "@mui/icons-material/Edit";
import {
  Typography,
  Box,
  TextField,
  Autocomplete,
  Dialog,
  DialogTitle,
  IconButton,
  Button,
  CardMedia,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import { UseOrders } from "../OrdersPage/UseOrders";
import SubmitButton from "./SubmitButton";
import WeightIcone from "../../images/icon/weight.png";
import zipcodeIcone from "../../images/icon/zip-code.png";
import motorbikeIcone from "../../images/icon/motorbike.png";
import mapIcone from "../../images/icon/map.png";
import mailboxIcone from "../../images/icon/mailbox.png";
import deliverymanIcone from "../../images/icon/delivery-man.png";
import deliveryIcone from "../../images/icon/delivery.png";
import addressIcone from "../../images/icon/home-address.png";
import descriptionIcone from "../../images/icon/edit-info.png";
import useBreakpoints from "../../hooks/useBreakpoints";
import ChangeLocation from "./ChangeLocation";
import { rsProgress } from "../../RecoilStates";
import { useRecoilState } from "recoil";

export default function SendInformation(props) {
  const {
    getOrdersLoc,
    setLocationData,
    locations,
    postsms,
    EditOrderInfo,
    updateOrder,
  } = UseOrders();
  const [data, setData] = useState(props.orderDetail);
  const [openInf, setOpenInf] = useState({
    show: false,
    dialogeContent: undefined,
  });
  const [deliveryType, setDeliveryType] = useState([]);
  const [delivery, setDelivery] = useState();
  const [valueAuto, setValueAuto] = useState("");
  const [sendType, setSendType] = useState("");
  const [postTimes, setPostTimes] = useState([]);
  const [allDelivery, setAllDelivery] = useState(true);
  const [lastDelivery, setLastDelivery] = useState();
  const [allDeliveryDay, setAllDeliveryDay] = useState();
  const [deliveryTimes, setDeliveryTimes] = useState([]);
  const [showchangelocState, setShowChangelocState] = useState(false);
  const [changelocState, setChangelocState] = useState({
    latitude: undefined,
    longitude: undefined,
  });
  const { isSmall } = useBreakpoints();
  const [progress, setProgress] = useRecoilState(rsProgress);

  useEffect(() => {
    getOrdersLoc(0, (provinces) => {
      setLocationData(provinces.provinces);
    });
  }, []);

  useEffect(() => {
    if (delivery && delivery.deliveryDays !== null) {
      setValueAuto({ name: "" });
      var tempArr = [];
      delivery.deliveryDays &&
        delivery.deliveryDays.map((m) => {
          m.deliveryTimes.map((model) => {
            model.name = m.day + " " + m.date + " " + model.title;
            model.deliveryID = model.deliveryID;
            model.isFull = model.isFull;
            model.disable = model.disable;
            tempArr.push(model);
            setDeliveryTimes(tempArr);
          });
        });
    }
    if (delivery && !delivery.deliveryDays) {
      setValueAuto({ name: delivery.deliveryTitle });
      setState({
        ...state,
        deliveryTypeID: delivery.deliveryID,
      });
      setPostTimes(delivery);
    }
  }, [delivery]);

  const [state, setState] = useState({
    postFollowupCode: "",
    address: "",
    postCode: "",
    deliveryType: "",
    deliveryTypeID: undefined,
    deliveryTime: "",
  });

  const [myLocations, setMyLocations] = useState({
    provinceID: data.provinceID,
    cityID: data.cityID,
    neighbourhoodID: data.neighbourhoodID ? data.neighbourhoodID : 0,
  });

  useEffect(() => {
    if (openInf.show == true) {
      if (openInf.dialogeContent == "editInfo") {
        EditOrderInfo(props.orderDetail.id, (callback) => {
          setAllDeliveryDay(callback.allMotorcycleDelivery);

          // callback.motorcycleDelivery.map((m) => {
          //   m.disable = !myLocations.neighbourhoodMotor;
          //   return m;
          // });
          let temp = callback.motorcycleDelivery ?? [];
          let tempLength = callback.motorcycleDelivery?.length ?? 0;

          let inpersonDeliveryLength =
            callback.motorcycleDelivery?.length +
              callback.postDelivery?.length ?? 0;

          let expressDeliveryLength =
            callback.motorcycleDelivery?.length +
            callback.postDelivery?.length +
            callback.inpersonDelivery?.length;

          callback.postDelivery.map((m) => {
            m.id = m.id + tempLength;
            temp.push(m);
          });

          callback.inpersonDelivery?.map((m) => {
            m.id = m.id + inpersonDeliveryLength + 1;
            temp.push(m);
          });

          callback.expressDelivery?.map((m) => {
            m.id = m.id + expressDeliveryLength + 1;
            temp.push(m);
          });
          setDeliveryType(temp);
          // setDeliveryType(temp);
          // setDeliveryTime(temp);
        });
      }
      // setSendType({ title: props.orderDetail.deliveryType });
      // setValueAuto({ name: props.orderDetail.deliveryTime });
      setState({
        postFollowupCode: props.orderDetail.postFollowupCode,
        address: props.orderDetail.address,
        postCode: props.orderDetail.postCode,
      });
    }
  }, [openInf]);

  return (
    <Box>
      <Dialog
        fullWidth
        maxWidth="xs"
        onClose={() => {
          setOpenInf({
            show: false,
            dialogeContent: undefined,
          });
          setDeliveryTimes([]);
          setSendType({ title: "" });
          setValueAuto({ name: "" });
          setDeliveryType([]);
          setState({
            postFollowupCode: "",
            address: "",
            postCode: "",
            deliveryType: "",
            deliveryTypeID: undefined,
            deliveryTime: "",
          });
          setMyLocations({
            provinceID: data.provinceID,
            cityID: data.cityID,
            neighbourhoodID: data.neighbourhoodID,
          });
        }}
        open={openInf.show}
      >
        <DialogTitle>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Typography variant="subtitle1">ویرایش اطلاعات</Typography>
            {openInf.dialogeContent == "province" && (
              <Button
                onClick={() => {
                  setMyLocations({
                    provinceID: 1,
                    cityID: 1,
                    neighbourhoodID: 0,
                  });
                }}
                variant="outlined"
              >
                تهران
              </Button>
            )}
          </Box>
        </DialogTitle>

        {openInf.dialogeContent == "province" && (
          <Box
            sx={{
              mx: 3,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: 2,
            }}
          >
            <Autocomplete
              size="small"
              value={myLocations.provinceID ? myLocations.provinceID : ""}
              onChange={(event, newValue) => {
                setMyLocations({
                  provinceID: newValue,
                  cityID: undefined,
                  neighbourhoodID: 0,
                });
              }}
              isOptionEqualToValue={(option, value) => {
                return value == "" || option === value;
              }}
              getOptionLabel={(option) => {
                if (option) {
                  return locations?.find((m) => m.id == option)?.title;
                }
                return "";
              }}
              fullWidth
              options={locations?.map((m) => m.id)}
              renderInput={(params) => (
                <TextField variant="outlined" {...params} label="استان" />
              )}
            />
            <Autocomplete
              size="small"
              value={myLocations.cityID ? myLocations.cityID : ""}
              onChange={(event, newValue) => {
                setMyLocations({
                  ...myLocations,
                  cityID: newValue,
                  neighbourhoodID: 0,
                });
              }}
              isOptionEqualToValue={(option, value) => {
                return value == "" || option === value;
              }}
              getOptionLabel={(option) => {
                if (option) {
                  return locations
                    ?.find((m) => m.id == myLocations.provinceID)
                    ?.cities?.find((m) => m.id == option)?.title;
                }
                return "";
              }}
              fullWidth
              options={locations
                ?.find((m) => m.id == myLocations.provinceID)
                .cities?.map((m) => m.id)}
              renderInput={(params) => (
                <TextField variant="outlined" {...params} label="شهر" />
              )}
            />

            <Autocomplete
              size="small"
              value={
                myLocations.neighbourhoodID ? myLocations.neighbourhoodID : ""
              }
              onChange={(event, newValue) => {
                setMyLocations({ ...myLocations, neighbourhoodID: newValue });
              }}
              isOptionEqualToValue={(option, value) => {
                return value == "" || option === value;
              }}
              getOptionLabel={(option) => {
                if (option) {
                  return locations
                    ?.find((m) => m.id == myLocations.provinceID)
                    ?.cities.find((m) => m.id == myLocations.cityID)
                    ?.neighbourhoods.length > 0
                    ? locations
                        ?.find((m) => m.id == myLocations.provinceID)
                        ?.cities.find((m) => m.id == myLocations.cityID)
                        ?.neighbourhoods?.find((m) => m.id == option)?.title
                    : "";
                }
                return "";
              }}
              fullWidth
              options={
                myLocations.cityID
                  ? locations
                      ?.find((m) => m.id == myLocations.provinceID)
                      ?.cities.find((m) => m.id == myLocations.cityID)
                      ?.neighbourhoods?.map((m) => m.id)
                  : []
              }
              renderInput={(params) => (
                <TextField variant="outlined" {...params} label="محله" />
              )}
            />
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <SubmitButton
                address
                Value={myLocations}
                id={props.orderDetail.id}
                callback={() => {
                  props.setOrderDetail({
                    ...props.orderDetail,
                    provinceID: myLocations.provinceID,
                    cityID: myLocations.cityID,
                    neighbourhoodID: myLocations.neighbourhoodID,
                  });
                  props.setReload(true);
                  setOpenInf({ ...openInf, show: false });
                }}
              />
              <Button
                sx={{ ml: 1 }}
                color="error"
                variant="outlined"
                onClick={() => setOpenInf({ ...openInf, show: false })}
              >
                انصراف
              </Button>
            </Box>
          </Box>
        )}

        {openInf.dialogeContent == "editInfo" && (
          <Box
            sx={{
              mx: 3,
              display: "flex",
              flexDirection: "column",
              // alignItems: "center",
              gap: 2,
            }}
          >
            <Autocomplete
              value={sendType ? sendType : ""}
              size="small"
              onChange={(event, newValue) => {
                if (newValue) {
                  if (newValue.title !== "ارسال عادی با پیک موتوری") {
                    setDeliveryTimes([]);
                  }
                  setLastDelivery(newValue);
                  setAllDelivery(true);
                  setSendType({ title: newValue.title });
                  setDelivery(newValue);
                  setState({
                    ...state,
                    deliveryType: newValue.title,
                  });
                } else {
                  setDeliveryTimes([]);
                  setValueAuto({ name: "" });
                  setSendType({ title: "" });
                  setDelivery();
                  setState({
                    ...state,
                    deliveryType: "",
                  });
                }
              }}
              getOptionDisabled={(option) => option.disable == true}
              renderOption={(props, option, { selected }) => {
                return (
                  <li {...props}>
                    <CardMedia
                      sx={{ width: "30px", mr: 1 }}
                      component="img"
                      image={option.icon}
                    />
                    <Typography variant="body2">{option.title}</Typography>
                  </li>
                );
              }}
              isOptionEqualToValue={(option, value) => {
                return value == "" || option === value;
              }}
              getOptionLabel={(option) => {
                if (option) {
                  return option.title;
                }
                return "";
              }}
              fullWidth
              options={deliveryType ? deliveryType : []}
              renderInput={(params) => (
                <TextField
                  // error={props.errorState.deliveryType}
                  variant="outlined"
                  {...params}
                  label="نوع ارسال جدید"
                />
              )}
            />
            <Autocomplete
              size="small"
              value={valueAuto ? valueAuto : ""}
              onChange={(event, newValue) => {
                if (newValue) {
                  setValueAuto({ name: newValue.name });
                  setState({
                    ...state,
                    deliveryTypeID: newValue.deliveryID,
                  });
                } else {
                  setValueAuto({ name: "" });
                  setState({
                    ...state,
                    deliveryTypeID: undefined,
                  });
                }
              }}
              isOptionEqualToValue={(option, value) => {
                return value == "" || option === value;
              }}
              getOptionDisabled={(option) =>
                option.disable == true || option.isFull == true
              }
              getOptionLabel={(option) => {
                if (option) {
                  return option ? option.name : "";
                }
                return "";
              }}
              renderOption={(props, option, { selected }) => {
                return (
                  <li {...props}>
                    <Typography
                      sx={{
                        color: option.isFull && "red",
                      }}
                    >
                      {option.name}
                    </Typography>
                  </li>
                );
              }}
              fullWidth
              options={deliveryTimes ? deliveryTimes : []}
              renderInput={(params) => (
                <TextField
                  // error={props.errorState.deliveryID}
                  variant="outlined"
                  {...params}
                  label="بازه ارسال جدید"
                />
              )}
            />

            {state.deliveryType == "ارسال عادی با پیک موتوری" ? (
              <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                {allDelivery == true ? (
                  <Button
                    variant="contained"
                    onClick={() => {
                      setAllDelivery(false);
                      setDelivery(allDeliveryDay[0]);
                      props.setRow({
                        ...props.row,
                        deliveryCost: allDeliveryDay[0].cost,
                      });
                      props.setState({
                        ...props.state,
                        deliveryType: allDeliveryDay[0].title,
                      });
                      setValueAuto({ name: "" });
                      props.setState({
                        ...props.state,
                        deliveryID: undefined,
                      });
                    }}
                  >
                    تمام بازه ها
                  </Button>
                ) : (
                  <Button
                    variant="contained"
                    color="secondary"
                    onClick={() => {
                      setAllDelivery(true);
                      setDelivery(lastDelivery);
                      setValueAuto({ name: "" });
                      props.setState({
                        ...props.state,
                        deliveryID: undefined,
                      });
                    }}
                  >
                    بازه های فعال
                  </Button>
                )}
              </Box>
            ) : (
              ""
            )}
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <SubmitButton
                editInfo={true}
                Value={state.deliveryTypeID}
                id={props.orderDetail.id}
                FiledName="DeliveryID"
                callback={() => {
                  props.setReload(true);
                  setOpenInf({ ...openInf, show: false });
                }}
              />
              <Button
                sx={{ ml: 1 }}
                color="error"
                variant="outlined"
                onClick={() => {
                  setSendType({ title: "" });
                  setValueAuto({ name: "" });
                  setDeliveryType([]);
                  setDeliveryTimes([]);
                  setOpenInf({ ...openInf, show: false });
                }}
              >
                انصراف
              </Button>
            </Box>
          </Box>
        )}

        {openInf.dialogeContent == "address" && (
          <Box
            sx={{
              mx: 3,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <TextField
              fullWidth
              multiline
              autoFocus
              rows={4}
              value={state.address ? state.address : ""}
              label="آدرس"
              size="small"
              variant="outlined"
              onChange={(evt) => {
                setState({
                  ...state,
                  address: evt.target.value,
                });
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <SubmitButton
                name="آدرس"
                Value={state.address}
                FiledName="address"
                id={props.orderDetail.id}
                callback={() => {
                  props.setReload(true);
                  props.setOrderDetail({
                    ...props.orderDetail,
                    address: state.address,
                  });
                  setOpenInf({ ...openInf, show: false });
                }}
              />
              <Button
                sx={{ ml: 1 }}
                color="error"
                variant="outlined"
                onClick={() => setOpenInf({ ...openInf, show: false })}
              >
                انصراف
              </Button>
            </Box>
          </Box>
        )}
        {openInf.dialogeContent == "postCode" && (
          <Box
            sx={{
              mx: 3,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <TextField
              fullWidth
              autoFocus
              value={state.postCode ? state.postCode : ""}
              label="کد پستی"
              size="small"
              variant="outlined"
              onChange={(evt) => {
                setState({
                  ...state,
                  postCode: evt.target.value,
                });
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <SubmitButton
                Value={state.postCode}
                FiledName="ZipCode"
                id={props.orderDetail.id}
                callback={() => {
                  props.setReload(true);
                  props.setOrderDetail({
                    ...props.orderDetail,
                    postCode: state.postCode,
                  });
                  setOpenInf({ ...openInf, show: false });
                }}
              />
              <Button
                sx={{ ml: 1 }}
                color="error"
                variant="outlined"
                onClick={() => setOpenInf({ ...openInf, show: false })}
              >
                انصراف
              </Button>
            </Box>
          </Box>
        )}
        {openInf.dialogeContent == "postFollowupCode" && (
          <Box
            sx={{
              mx: 3,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <TextField
              fullWidth
              autoFocus
              value={state.postFollowupCode ? state.postFollowupCode : ""}
              label="شماره پیگیری پست"
              size="small"
              variant="outlined"
              onChange={(evt) => {
                setState({
                  ...state,
                  postFollowupCode: evt.target.value,
                });
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <SubmitButton
                Value={state.postFollowupCode}
                FiledName="PostRef"
                id={props.orderDetail.id}
                callback={() => {
                  props.setReload(true);
                  props.setOrderDetail({
                    ...props.orderDetail,
                    postFollowupCode: state.postFollowupCode,
                  });
                  setOpenInf({ ...openInf, show: false });
                }}
              />
              <Button
                sx={{ ml: 1 }}
                color="error"
                variant="outlined"
                onClick={() => setOpenInf({ ...openInf, show: false })}
              >
                انصراف
              </Button>
            </Box>
          </Box>
        )}
      </Dialog>
      <Box sx={{ p: 2, mb: 2 }}>
        <Typography sx={{ mb: 2 }} color="secondary" variant="h6">
          اطلاعات ارسال
        </Typography>
        <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={2}>
          <Box
            gridColumn={isSmall ? "span 12" : "span 4"}
            sx={{ display: "flex", alignItems: "flex-start" }}
          >
            <Box
              sx={{
                width: "180px",
                bgcolor: "#EFF2F7",
                border: "1px solid #d5dde6",
                py: 1,
                mr: 1,
                display: "flex",
                alignItems: "center",
              }}
            >
              <CardMedia
                sx={{ width: "20px", ml: 1 }}
                component="img"
                alt="green iguana"
                image={mapIcone}
              />
              <Typography sx={{ ml: 1, color: "#3e485c" }} variant="subtitle2">
                استان
              </Typography>
            </Box>
            <Box
              sx={{
                flex: 2,
                bgcolor: "#f9fafc",
                border: "1px solid #d5dde6",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                py: 1,
                px: 2,
              }}
            >
              <Typography
                sx={{
                  textAlign: "center",
                  color: "#3e485c",
                }}
                variant="subtitle2"
              >
                {props.orderDetail.province}
              </Typography>
              <IconButton
                onClick={() =>
                  setOpenInf({
                    show: true,
                    dialogeContent: "province",
                  })
                }
                sx={{ p: 0 }}
              >
                <EditIcon fontSize="small" color="secondary" />
              </IconButton>
            </Box>
          </Box>
          <Box
            gridColumn={isSmall ? "span 12" : "span 4"}
            sx={{ display: "flex", alignItems: "flex-start" }}
          >
            <Box
              sx={{
                width: "180px",
                bgcolor: "#EFF2F7",
                border: "1px solid #d5dde6",
                py: 1,
                mr: 1,
                display: "flex",
                alignItems: "center",
              }}
            >
              <CardMedia
                sx={{ width: "20px", ml: 1 }}
                component="img"
                alt="green iguana"
                image={mapIcone}
              />
              <Typography sx={{ ml: 1, color: "#3e485c" }} variant="subtitle2">
                شهر
              </Typography>
            </Box>
            <Box
              sx={{
                flex: 2,
                bgcolor: "#f9fafc",
                border: "1px solid #d5dde6",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                py: 1,
                px: 2,
              }}
            >
              <Typography
                sx={{
                  textAlign: "center",
                  color: "#3e485c",
                }}
                variant="subtitle2"
              >
                {props.orderDetail.city}
              </Typography>
              <IconButton
                onClick={() =>
                  setOpenInf({
                    show: true,
                    dialogeContent: "province",
                  })
                }
                sx={{ p: 0 }}
              >
                <EditIcon fontSize="small" color="secondary" />
              </IconButton>
            </Box>
          </Box>
          <Box
            gridColumn={isSmall ? "span 12" : "span 4"}
            sx={{ display: "flex", alignItems: "flex-start" }}
          >
            <Box
              sx={{
                width: "180px",
                bgcolor: "#EFF2F7",
                border: "1px solid #d5dde6",
                py: 1,
                mr: 1,
                display: "flex",
                alignItems: "center",
              }}
            >
              <CardMedia
                sx={{ width: "20px", ml: 1 }}
                component="img"
                alt="green iguana"
                image={mapIcone}
              />
              <Typography sx={{ ml: 1, color: "#3e485c" }} variant="subtitle2">
                محله
              </Typography>
            </Box>
            <Box
              sx={{
                flex: 2,
                bgcolor: "#f9fafc",
                border: "1px solid #d5dde6",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                py: 1,
                px: 2,
              }}
            >
              <Typography
                sx={{
                  textAlign: "center",
                  color: "#3e485c",
                }}
                variant="subtitle2"
              >
                {props.orderDetail.neighbourhood}
              </Typography>
              <IconButton
                onClick={() =>
                  setOpenInf({
                    show: true,
                    dialogeContent: "province",
                  })
                }
                sx={{ p: 0 }}
              >
                <EditIcon fontSize="small" color="secondary" />
              </IconButton>
            </Box>
          </Box>
          <Box
            gridColumn="span 12"
            sx={{ display: "flex", alignItems: "flex-start" }}
          >
            <Box
              sx={{
                width: "180px",
                bgcolor: "#EFF2F7",
                border: "1px solid #d5dde6",
                py: 1,
                mr: 1,
                display: "flex",
                alignItems: "center",
              }}
            >
              <CardMedia
                sx={{ width: "20px", ml: 1 }}
                component="img"
                alt="green iguana"
                image={addressIcone}
              />
              <Typography sx={{ ml: 1, color: "#3e485c" }} variant="subtitle2">
                آدرس
              </Typography>
            </Box>
            <Box
              sx={{
                flex: 5,
                bgcolor: "#f9fafc",
                border: "1px solid #d5dde6",
                display: "flex",
                alignItems: "flex-start",
                justifyContent: "space-between",
                py: 1,
                px: 2,
              }}
            >
              <Typography
                sx={{
                  textAlign: "left",
                  color: "#3e485c",
                  whiteSpace: "pre-line",
                }}
                variant="subtitle2"
              >
                {props.orderDetail.address}
              </Typography>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                }}
              >
                <CardMedia
                  component="img"
                  sx={{ cursor: "pointer", width: "30px", height: "30px" }}
                  image="/static/img/map.svg"
                  onClick={() => {
                    setShowChangelocState(true);
                    setChangelocState({
                      latitude: props.orderDetail.latitude,
                      longitude: props.orderDetail.longitude,
                    });
                  }}
                />
                <IconButton
                  onClick={() =>
                    setOpenInf({
                      show: true,
                      dialogeContent: "address",
                    })
                  }
                  sx={{ p: 0 }}
                >
                  <EditIcon fontSize="small" color="secondary" />
                </IconButton>
              </Box>
            </Box>
          </Box>
          <Box
            gridColumn={isSmall ? "span 12" : "span 4"}
            sx={{ display: "flex", alignItems: "flex-start" }}
          >
            <Box
              sx={{
                width: "180px",
                bgcolor: "#EFF2F7",
                border: "1px solid #d5dde6",
                py: 1,
                mr: 1,
                display: "flex",
                alignItems: "center",
              }}
            >
              <CardMedia
                sx={{ width: "20px", ml: 1 }}
                component="img"
                alt="green iguana"
                image={zipcodeIcone}
              />
              <Typography sx={{ ml: 1, color: "#3e485c" }} variant="subtitle2">
                کد پستی
              </Typography>
            </Box>
            <Box
              sx={{
                flex: 2,
                bgcolor: "#f9fafc",
                border: "1px solid #d5dde6",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                py: 1,
                px: 2,
              }}
            >
              <Typography
                sx={{
                  textAlign: "center",
                  color: "#3e485c",
                }}
                variant="subtitle2"
              >
                {props.orderDetail.postCode}
              </Typography>
              <IconButton
                onClick={() =>
                  setOpenInf({
                    show: true,
                    dialogeContent: "postCode",
                  })
                }
                sx={{ p: 0 }}
              >
                <EditIcon fontSize="small" color="secondary" />
              </IconButton>
            </Box>
          </Box>
          <Box
            gridColumn={isSmall ? "span 12" : "span 4"}
            sx={{ display: "flex", alignItems: "flex-start" }}
          >
            <Box
              sx={{
                width: "180px",
                bgcolor: "#EFF2F7",
                border: "1px solid #d5dde6",
                py: 1,
                mr: 1,
                display: "flex",
                alignItems: "center",
              }}
            >
              <CardMedia
                sx={{ width: "20px", ml: 1 }}
                component="img"
                alt="green iguana"
                image={WeightIcone}
              />
              <Typography sx={{ ml: 1, color: "#3e485c" }} variant="subtitle2">
                وزن مجموع
              </Typography>
            </Box>
            <Box
              sx={{
                flex: 2,
                bgcolor: "#f9fafc",
                border: "1px solid #d5dde6",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                py: 1,
                px: 2,
              }}
            >
              <Typography
                sx={{
                  textAlign: "center",
                  color: "#3e485c",
                }}
                variant="subtitle2"
              >
                {props.orderDetail.weight}
              </Typography>
            </Box>
          </Box>
          <Box
            gridColumn={isSmall ? "span 12" : "span 4"}
            sx={{ display: "flex", alignItems: "flex-start" }}
          >
            <Box
              sx={{
                width: "180px",
                bgcolor: "#EFF2F7",
                border: "1px solid #d5dde6",
                py: 1,
                mr: 1,
                display: "flex",
                alignItems: "center",
              }}
            >
              <CardMedia
                sx={{ width: "20px", ml: 1 }}
                component="img"
                alt="green iguana"
                image={motorbikeIcone}
              />
              <Typography sx={{ ml: 1, color: "#3e485c" }} variant="subtitle2">
                نوع ارسال
              </Typography>
            </Box>
            <Box
              sx={{
                flex: 2,
                bgcolor: "#f9fafc",
                border: "1px solid #d5dde6",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                py: 1,
                px: 2,
              }}
            >
              <Typography
                sx={{
                  textAlign: "center",
                  color: "#3e485c",
                }}
                variant="subtitle2"
              >
                {props.orderDetail.deliveryType}
              </Typography>
              <IconButton
                onClick={() =>
                  setOpenInf({
                    show: true,
                    dialogeContent: "editInfo",
                  })
                }
                sx={{ p: 0 }}
              >
                <EditIcon fontSize="small" color="secondary" />
              </IconButton>
            </Box>
          </Box>
          <Box
            gridColumn={isSmall ? "span 12" : "span 6"}
            sx={{ display: "flex", alignItems: "flex-start" }}
          >
            <Box
              sx={{
                width: "180px",
                bgcolor: "#EFF2F7",
                border: "1px solid #d5dde6",
                py: 1,
                mr: 1,
                display: "flex",
                alignItems: "center",
              }}
            >
              <CardMedia
                sx={{ width: "20px", ml: 1 }}
                component="img"
                alt="green iguana"
                image={deliveryIcone}
              />
              <Typography sx={{ ml: 1, color: "#3e485c" }} variant="subtitle2">
                بازه ارسال
              </Typography>
            </Box>
            <Box
              sx={{
                flex: 4,
                bgcolor: "#f9fafc",
                border: "1px solid #d5dde6",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                py: 1,
                px: 2,
              }}
            >
              <Typography
                sx={{
                  textAlign: "left",
                  color: "#3e485c",
                }}
                variant="subtitle2"
              >
                {props.orderDetail.deliveryTime}
              </Typography>
              <IconButton
                onClick={() =>
                  setOpenInf({
                    show: true,
                    dialogeContent: "editInfo",
                  })
                }
                sx={{ p: 0 }}
              >
                <EditIcon fontSize="small" color="secondary" />
              </IconButton>
            </Box>
          </Box>
          <Box
            gridColumn={isSmall ? "span 12" : "span 6"}
            sx={{ display: "flex", alignItems: "flex-start" }}
          >
            <Box
              sx={{
                width: "180px",
                bgcolor: "#EFF2F7",
                border: "1px solid #d5dde6",
                py: 1,
                mr: 1,
                display: "flex",
                alignItems: "center",
              }}
            >
              <CardMedia
                sx={{ width: "20px", ml: 1 }}
                component="img"
                alt="green iguana"
                image={deliverymanIcone}
              />
              <Typography sx={{ ml: 1, color: "#3e485c" }} variant="subtitle2">
                مامور ارسال
              </Typography>
            </Box>
            <Box
              sx={{
                flex: 2,
                bgcolor: "#f9fafc",
                border: "1px solid #d5dde6",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                py: 1,
                px: 2,
              }}
            >
              <Typography
                sx={{
                  textAlign: "center",
                  color: "#3e485c",
                }}
                variant="subtitle2"
              >
                {props.orderDetail.deliveryDriverName
                  ? props.orderDetail.deliveryDriverName
                  : "نامشخص"}
              </Typography>
            </Box>
          </Box>
          <Box
            gridColumn={isSmall ? "span 12" : "span 7"}
            sx={{ display: "flex", alignItems: "center" }}
          >
            <Box
              sx={{
                width: "180px",
                bgcolor: "#EFF2F7",
                border: "1px solid #d5dde6",
                py: 1,
                mr: 1,
                display: "flex",
                alignItems: "center",
              }}
            >
              <CardMedia
                sx={{ width: "20px", ml: 1 }}
                component="img"
                alt="green iguana"
                image={mailboxIcone}
              />
              <Typography sx={{ ml: 1, color: "#3e485c" }} variant="subtitle2">
                کد رهگیری پست
              </Typography>
            </Box>
            <Box
              sx={{
                flex: 2,
                bgcolor: "#f9fafc",
                border: "1px solid #d5dde6",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                py: 1,
                px: 2,
              }}
            >
              <Typography
                sx={{
                  textAlign: "center",
                  color: "#3e485c",
                }}
                variant="subtitle2"
              >
                {props.orderDetail.postFollowupCode}
              </Typography>
              <IconButton
                onClick={() =>
                  setOpenInf({
                    show: true,
                    dialogeContent: "postFollowupCode",
                  })
                }
                sx={{ p: 0 }}
              >
                <EditIcon fontSize="small" color="secondary" />
              </IconButton>
            </Box>
            <Button
              onClick={() => {
                postsms(props.orderDetail.id);
              }}
              sx={{ ml: 1 }}
              size="small"
              variant="contained"
            >
              ارسال SMS
            </Button>
          </Box>
          <Box
            gridColumn={isSmall ? "span 12" : "span 5"}
            sx={{ display: "flex", alignItems: "center" }}
          >
            <Box
              sx={{
                width: "180px",
                bgcolor: "#EFF2F7",
                border: "1px solid #d5dde6",
                py: 1,
                mr: 1,
                display: "flex",
                alignItems: "center",
              }}
            >
              <CardMedia
                sx={{ width: "20px", ml: 1 }}
                component="img"
                alt="green iguana"
                image={mailboxIcone}
              />
              <Typography sx={{ ml: 1, color: "#3e485c" }} variant="subtitle2">
                فاکتور کاغذی ارسال شود
              </Typography>
            </Box>
            <Box
              sx={{
                flex: 2,
                bgcolor: props.orderDetail.sendFactor ? "#f9fafc" : "#ffc4c4",
                border: "1px solid",
                borderColor: props.orderDetail.sendFactor
                  ? "#d5dde6"
                  : "#ff8c8c",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                py: 1,
                px: 2,
              }}
            >
              <Typography
                sx={{
                  textAlign: "center",
                  color: "#3e485c",
                }}
                variant="subtitle2"
              >
                {!props.orderDetail.sendFactor ? "خیر" : "بله"}
              </Typography>
            </Box>
          </Box>

          <Box
            gridColumn="span 12"
            sx={{ display: "flex", alignItems: "flex-start" }}
          >
            <Box
              sx={{
                width: "180px",
                bgcolor: "#EFF2F7",
                border: "1px solid #d5dde6",
                py: 1,
                mr: 1,
                display: "flex",
                alignItems: "center",
              }}
            >
              <CardMedia
                sx={{ width: "20px", ml: 1 }}
                component="img"
                alt="green iguana"
                image={descriptionIcone}
              />
              <Typography sx={{ ml: 1, color: "#3e485c" }} variant="subtitle2">
                توضیحات
              </Typography>
            </Box>
            <Box
              sx={{
                flex: 5,
                bgcolor: "#f9fafc",
                border: "1px solid #d5dde6",
                py: 1,
                px: 2,
                height: "100px",
              }}
            >
              <Typography
                sx={{
                  textAlign: "left",
                  color: "#3e485c",
                  whiteSpace: "pre-line",
                }}
                variant="subtitle2"
              >
                {props.orderDetail.description}
              </Typography>
            </Box>
          </Box>
        </Box>
      </Box>
      {showchangelocState && (
        <ChangeLocation
          showchangelocState={showchangelocState}
          setShowChangelocState={setShowChangelocState}
          myLocations={changelocState}
          setMyLocations={setChangelocState}
          callback={() => {
            let body = {
              OrderId: props.orderDetail.id,
              Items: [
                {
                  FiledName: "latitude",
                  Value: changelocState.latitude,
                },
                {
                  FiledName: "longitude",
                  Value: changelocState.longitude,
                },
              ],
            };
            setProgress(true);
            updateOrder(body, (callback) => {
              props.setReload(true);
              setShowChangelocState(false);
            });
          }}
        />
      )}
    </Box>
  );
}
